import { render } from "./authorization-report.vue?vue&type=template&id=162fdc0b&scoped=true"
import script from "./authorization-report.vue?vue&type=script&lang=js"
export * from "./authorization-report.vue?vue&type=script&lang=js"

import "./authorization-report.vue?vue&type=style&index=0&id=162fdc0b&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-162fdc0b"]])

export default __exports__